import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import Cookies from 'js-cookie'
import CKEditor from '@ckeditor/ckeditor5-vue2';
Vue.use( CKEditor );

Vue.use(ElementUI);

Vue.config.productionTip = false

if (process.env.NODE_ENV == 'development'){
  Vue.prototype.apiUrl = 'http://api.semgjd.cyy';
  Vue.prototype.siteUrl = 'http://www.semgjd.cyy';
  axios.defaults.baseURL = Vue.prototype.apiUrl
}else {
  Vue.prototype.apiUrl = 'http://api.semgjd.com';
  Vue.prototype.siteUrl = 'http://www.semgjd.com';
  axios.defaults.baseURL = Vue.prototype.apiUrl
}

Vue.prototype.$http = axios
Vue.prototype.$http.defaults.withCredentials = true;

//http request 拦截器
axios.interceptors.request.use(
    config => {
      if (Cookies.get('access_token')) {
        var access_token = Cookies.get('access_token')// 判断是否存在token，如果存在的话，则每个http header都加上token
        var password = ''
        //config.headers.Authorization = 'Basic ' + Base64.encode(access_token+':'+password);
        config.headers.Authorization = 'Bearer ' + access_token;
      }
      return config;
    },
    err => {
      return Promise.reject(err);
    });
var _this = this
// http response 拦截器
axios.interceptors.response.use(
    response => {
      return response;
    },
    error => {
      if (error.response) {
        switch (error.response.status) {
          case 401:
            // 返回 401 清除token信息并跳转到登录页面
              Cookies.remove('access_token');
              Cookies.remove('user_id');
            var screenWidth = window.screen.width;
            if (screenWidth > 800){
              location.href = Vue.prototype.apiUrl+'/#/admin/login';
            }else {
              //location.href = Vue.prototype.loginDomain+'/jz/#/login?redirectUrl='+encodeURIComponent(location.href)
            }
        }
      }
      return Promise.reject(error)   // 返回接口返回的错误信息
    });

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
